import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { closeModal, createDevice } from '../actions/entry';
import { channelsSelector, deviceModelsSelector, devicesSelector } from '../selectors';
import DeviceAddModal from '../components/DeviceModal/AddDevice';

const mapStateToProps = (state) => ({ deviceCreateForm: { data: defaultData, isSubmitting } }) => {
  const channels = channelsSelector(state);
  const devices = devicesSelector(state);
  const models = deviceModelsSelector(state);
  return {
    devices,
    models,
    channels,
    defaultData,
    isSubmitting,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onCreate: createDevice,
      onClose: closeModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DeviceAddModal);
